import * as THREE from "three";

/**
 * Overhead UI sprites — floating name labels, health bars, chat/dialogue bubbles, and the working-FX
 * icons (mining pickaxe, crafting gear, skinning knife) — live on this dedicated camera LAYER so they
 * can be drawn in a CRISP overlay pass AFTER the depth-of-field post-processing, untouched by the
 * world blur.
 *
 * Why: these sprites render with `depthTest:false` / `depthWrite:false`, so they don't contribute to
 * the depth buffer. The HD-2D depth-of-field then computes each pixel's circle-of-confusion from
 * whatever sits BEHIND the sprite. Pitch the camera up and that's the far sky → huge CoC → the label/
 * icon gets smeared. Pulling them onto their own layer and compositing them last sidesteps the DoF
 * entirely. See `world3d.setupComposer()` (main camera excludes this layer) and the overlay render in
 * the main loop.
 */
export const UI_LAYER = 1;

/** Tag a sprite/object (and all its descendants) as overhead UI so the crisp overlay pass draws it. */
export function asOverheadUI<T extends THREE.Object3D>(o: T): T {
  o.traverse((c) => c.layers.set(UI_LAYER));
  return o;
}
